import { post,put,del,get } from './axios'

export const getBannerDetail = async (params) => {
  const { status, data } = await get("/banner/selectBannerDetailAjax", params)

  if (status === 200 || status === 201) {
      return data
  }
  
}

export const bannerList = async (params) => {
  const { status, data } = await get("/banner/selectBannerAjax", params)

  if (status === 200 || status === 201) {
      return data
  }
  
}


export const sideBannerList = async (params) => {
  const { status, data } = await get("/sideBanner/selectSideBannerAjax", params)

  if (status === 200 || status === 201) {
      return data
  }
  
}
